import { cn } from '@shadcn/lib/utils';
import {
  Sheet as ShadcnSheet,
  SheetContent as ShadcnSheetContent,
  SheetDescription as ShadcnSheetDescription,
  SheetHeader as ShadcnSheetHeader,
  SheetTitle as ShadcnSheetTitle,
  SheetTrigger as ShadcnSheetTrigger,
} from '@shadcn/ui/sheet';
import React from 'react';

interface ISheetProps extends React.ComponentProps<typeof ShadcnSheet> {
  readonly children: React.ReactNode;
}

function Sheet({ children, ...props }: ISheetProps) {
  return <ShadcnSheet {...props}>{children}</ShadcnSheet>;
}

interface ISheetContentProps extends React.ComponentProps<typeof ShadcnSheetContent> {
  children: React.ReactNode;
  description?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  title?: string;
  className?: string;
}

const SheetContent = React.forwardRef<HTMLDivElement, ISheetContentProps>(
  ({ side = 'left', title, description, children, className, ...props }, ref) => {
    return (
      <ShadcnSheetContent ref={ref} side={side} {...props} className={cn('bg-neutral-100', className)}>
        {(title || description) && (
          <ShadcnSheetHeader className="p-6">
            {title && <ShadcnSheetTitle>{title}</ShadcnSheetTitle>}
            {description && <ShadcnSheetDescription>{description}</ShadcnSheetDescription>}
          </ShadcnSheetHeader>
        )}
        <div className="pl-6 pr-6">{children}</div>
      </ShadcnSheetContent>
    );
  }
);
SheetContent.displayName = 'SheetContent';

interface ISheetTriggerProps {
  children: React.ReactNode;
  asChild?: boolean;
}

const SheetTrigger = React.forwardRef<HTMLButtonElement, ISheetTriggerProps>(({ children, ...props }, ref) => {
  return (
    <ShadcnSheetTrigger ref={ref} {...props}>
      {children}
    </ShadcnSheetTrigger>
  );
});

export { Sheet, SheetContent, SheetTrigger };
